// eslint-disable-next-line no-undef
export const AbilitySelectorEnum = new Map([[0, 'ability'], [1, 'task']]);
